import {v4 as uuidv4} from 'uuid';
import {AuditNonce} from '../../documents';

export const TSYS_ACQ_AUDIT_ID = 'TSYS_ACQ';

export const createAuditNonce = (uid: string): AuditNonce => {
  return {uuid: uuidv4(), uid};
};
